export const API_ENDPOINTS = {
  AUTH: {
    SEND_OTP: '/auth/send-otp',

    VERIFY_OTP: '/auth/verify-otp',

    ME: '/auth/me',

    PROFILE: '/auth/profile',

    LOGOUT: '/auth/logout',

    DELETE_ACCOUNT: '/auth/delete-account'
  },

  PRODUCTS: '/products',

  PLANS: '/plans',

  CART: '/cart',

  ORDERS: '/orders',

  PAYMENTS: '/payments',

  SUBSCRIPTIONS: '/subscriptions',

  REPORTS: '/reports',

  ADMIN: '/admin',

  GYMS: '/gyms'
}
